/*
 * Scenario: write-note-edit
 *
 * Phase-3: write_note auf einem bestehenden aktiven Absatz. Aendert Note-Text
 * + outlineDepth in einem Auto-Apply. Voraussetzung: der Cursor steht auf
 * einem Absatz, dessen Note geaendert werden soll.
 */

import { emit, resolve } from './_helpers.js'

export const name = 'write-note-edit'
export const description = 'Update an existing sketch note on the current paragraph (auto-apply).'

export async function run(state) {
    const toolCallId = 'tu_note_' + Date.now().toString(36)
    const paragraphId = resolve(state, '$cursor.paragraphId')
    const baseVersion = resolve(state, '$cursor.version')

    await emit(state, 'session', { sessionId: 'mock-write-note' }, 0)
    await emit(state, 'thinking', {
        text: 'Refining your sketch point…'
    }, 200)
    await emit(state, 'thinkingDone', {}, 100)
    await emit(state, 'toolCall', {
        toolCallId, tool: 'write_note', input: { paragraph_id: paragraphId }
    }, 80)

    await emit(state, 'proposeWriteNote', {
        toolCallId,
        paragraphId,
        baseVersion: typeof baseVersion === 'number' ? baseVersion : undefined,
        note: 'Anna enters quietly — the door barely makes a sound',
        outlineDepth: 1
    }, 300)

    await emit(state, 'toolResult', {
        toolCallId, tool: 'write_note', summary: 'applied'
    }, 80)

    await emit(state, 'delta', {
        text: 'Refined the sketch point directly. Outline tree shows the change immediately — Cmd+Z to undo.'
    }, 250)
    await emit(state, 'done', { usage: {} }, 100)
}
